import { render, staticRenderFns } from "./BeefPolicyTypeList.vue?vue&type=template&id=31bf1992&scoped=true"
import script from "./BeefPolicyTypeList.vue?vue&type=script&lang=js"
export * from "./BeefPolicyTypeList.vue?vue&type=script&lang=js"
import style0 from "./BeefPolicyTypeList.vue?vue&type=style&index=0&id=31bf1992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf1992",
  null
  
)

export default component.exports